import axios from "axios";
import { Button, Pane, Text } from "evergreen-ui";
import { MDBDataTableV5 } from "mdbreact";
import React, { useState } from "react";
import { useEffect } from "react";

function Tuitionfees() {
  const [DataNormall1, setDataNormall1] = useState([]);
  const [DataNormall2, setDataNormall2] = useState([]);
  const [DataNormall3, setDataNormall3] = useState([]);
  const [DataNormall4, setDataNormall4] = useState([]);
  const [DataNormall5, setDataNormall5] = useState([]);
  const [DataNormall6, setDataNormall6] = useState([]);
  const [DataUnNormall3, setDataUnNormall3] = useState([]);
  const [DataUnNormall4, setDataUnNormall4] = useState([]);
  const [DataUnNormall5, setDataUnNormall5] = useState([]);

  const [KsbpK4, setKsbpK4] = useState([]);
  const [KsbpK3, setKsbpK3] = useState([]);
  const [KsbpK5, setKsbpK5] = useState([]);

  const [KsbpM4, setKsbpM4] = useState([]);
  const [KsbpM2, setKsbpM2] = useState([]);
  const [KsbpM3, setKsbpM3] = useState([]);

  const [BunditT2, setBunditT2] = useState([]);
  const [BunditT1, setBunditT1] = useState([]);
  const [BunditT3, setBunditT3] = useState([]);
  const [BunditT4, setBunditT4] = useState([]);

  const [BunditD1, setBunditD1] = useState([]);

  useEffect(() => {
    const columns = [
      {
        label: "สาขาวิชา/วิชาเอก",
        field: "major",
        minimal:'sm'
      },
      {
        label: "ค่าเทอมรวมรายวิชาปฏิบัติ",
        field: "fees",
        minimal:'lg'
      },
      {
        label: "คู่มือนักศึกษา",
        field: "manual",
      },
      {
        label: "ลงทะเบียนนักศึกษาใหม่",
        field: "newstd",
      },
      {
        label: "ออกบัตร",
        field: "card",
      },
      {
        label: "ประกันของเสียหาย",
        field: "garantee",
      },
      {
        label: "รวม",
        field: "total",
        minimal:'lg'
      },
      {
        label: "ประมาณการค่าใช้จ่ายตลอดหลักสูตร",
        field: "all",
        minimal:'lg'
      },
    ];
    getTable("1", "1")
      .then((table) => {
        setDataNormall1({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("1", "2")
      .then((table) => {
        setDataNormall2({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("1", "3")
      .then((table) => {
        setDataNormall3({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("1", "4")
      .then((table) => {
        setDataNormall4({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("1", "5")
      .then((table) => {
        setDataNormall5({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("1", "8")
      .then((table) => {
        setDataNormall6({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("5", "3")
      .then((table) => {
        setDataUnNormall3({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("5", "4")
      .then((table) => {
        setDataUnNormall4({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("5", "5")
      .then((table) => {
        setDataUnNormall5({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("2", "4")
      .then((table) => {
        setKsbpK4({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("2", "3")
      .then((table) => {
        setKsbpK3({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("2", "5")
      .then((table) => {
        setKsbpK5({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("3", "4")
      .then((table) => {
        setKsbpM4({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("3", "3")
      .then((table) => {
        setKsbpM3({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("3", "5")
      .then((table) => {
        setKsbpM2({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: (
                <>
                  {" "}
                  {parseInt(i.term_fees)} - {parseInt(i.term_fees) + 2200}
                </>
              ),
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: (
                <>
                  {parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2200}
                </>
              ),
              all: (
                <>
                  {i.all_term_fees} - {parseInt(i.all_term_fees) + 22000}
                </>
              ),
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("4", "2")
      .then((table) => {
        setBunditT2({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: <> {parseInt(i.term_fees)}</>,
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: <>{parseInt(i.term_fees) + parseInt(i.amout)}</>,
              all: <>{i.all_term_fees}</>,
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("4", "1")
      .then((table) => {
        setBunditT1({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: <> {parseInt(i.term_fees)} - 26000</>,
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: <>{parseInt(i.term_fees) + parseInt(i.amout)} - {parseInt(i.term_fees) + parseInt(i.amout) + 2000}</>,
              all: <>{parseInt(i.all_term_fees) + parseInt(i.amout)} - {parseInt(i.all_term_fees) + parseInt(i.amout)+10000}</>,

            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("4", "3")
      .then((table) => {
        setBunditT3({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: <> {parseInt(i.term_fees)}</>,
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: <>{parseInt(i.term_fees) + parseInt(i.amout)}</>,
              all: <>{i.all_term_fees}</>,
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("4", "4")
      .then((table) => {
        setBunditT4({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: <> {parseInt(i.term_fees)}</>,
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: <>{parseInt(i.term_fees) + parseInt(i.amout)}</>,
              all: <>{i.all_term_fees}</>,
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
    getTable("7", "2")
      .then((table) => {
        setBunditD1({
          columns: columns,
          rows: [
            ...table.map((i, key) => ({
              major: i.major_name,
              fees: <> {parseInt(i.term_fees)}</>,
              manual: i.manual_fees,
              newstd: i.news_std_fees,
              card: i.std_card,
              garantee: i.garantee,
              total: <>{parseInt(i.term_fees) + parseInt(i.amout)}</>,
              all: <>{i.all_term_fees} - 246100</>,
            })),
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const getTable = (type, fac) => {
    return new Promise((resolve, reject) => {
      axios
        .post("https://admission.kpru.ac.th/admission2017/student/Tuitionfee", {
          type,
          fac,
        })
        .then((res) => {
          if (res.data.length !== 0) {
            const table = res.data;
            resolve(table);
          } else {
            reject(new Error("Empty response"));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  return (
    <Pane className="container-md mt-2 p-3" display="flex" flexDirection="column" gap={10}>
      {/* <T */}
      <Text className="text-center" fontFamily="" fontSize={22} fontWeight={700}>
        อัตราค่าธรรมเนียมการศึกษา ภาคปกติ(กำแพงเพชร) <Button appearance="primary" size="small"  onClick={()=>{window.open("https://reg.kpru.ac.th/th/base_rule.asp")}} >ดูระเบียบ ข้อบังคับ</Button>
      </Text>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะครุศาสตร์
        </Text>
        <MDBDataTableV5 responsive striped theadColor="light-blue" searchBottom={false} searchTop barReverse theadTextWhite data={DataNormall2} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะวิทยาศาสตร์และเทคโนโลยี
        </Text>
        <MDBDataTableV5 responsive striped theadColor="yellow" data={DataNormall1} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะมนุษยศาสตร์และสังคมศาสตร์
        </Text>
        <MDBDataTableV5 responsive striped theadColor="orange" theadTextWhite data={DataNormall3} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะวิทยาการจัดการ
        </Text>
        <MDBDataTableV5 responsive striped theadColor="pink" theadTextWhite data={DataNormall4} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะเทคโนโลยีอุตสาหกรรม
        </Text>
        <MDBDataTableV5 responsive striped theadColor="purple" theadTextWhite data={DataNormall5} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะพยาบาลศาสตร์
        </Text>
        <MDBDataTableV5 responsive striped theadColor="green" theadTextWhite data={DataNormall6} />
      </Pane>
      <Text className="text-center mt-5" fontFamily="" fontSize={22} fontWeight={700}>
        อัตราค่าธรรมเนียมการศึกษา ภาคปกติ(แม่สอด)
      </Text>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะมนุษยศาสตร์และสังคมศาสตร์
        </Text>
        <MDBDataTableV5 responsive striped theadColor="orange" theadTextWhite data={DataUnNormall3} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะวิทยาการจัดการ
        </Text>
        <MDBDataTableV5 responsive striped theadColor="pink" theadTextWhite data={DataUnNormall4} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะเทคโนโลยีอุตสาหกรรม
        </Text>
        <MDBDataTableV5 responsive striped theadColor="purple" theadTextWhite data={DataUnNormall5} />
      </Pane>
      <Text className="text-center mt-5" fontFamily="" fontSize={22} fontWeight={700}>
        อัตราค่าธรรมเนียมการศึกษา ภาคกศ.บป. (กำแพงเพชร)
      </Text>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะวิทยาการจัดการ
        </Text>
        <MDBDataTableV5 responsive striped theadColor="pink" theadTextWhite data={KsbpK4} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะมนุษยศาสตร์และสังคมศาสตร์
        </Text>
        <MDBDataTableV5 responsive striped theadColor="orange" theadTextWhite data={KsbpK3} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะเทคโนโลยีอุตสาหกรรม
        </Text>
        <MDBDataTableV5 responsive striped theadColor="purple" theadTextWhite data={KsbpK5} />
      </Pane>
      <Text className="text-center mt-5" fontFamily="" fontSize={22} fontWeight={700}>
        อัตราค่าธรรมเนียมการศึกษา ภาคกศ.บป. (แม่สอด)
      </Text>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะเทคโนโลยีอุตสาหกรรม
        </Text>
        <MDBDataTableV5 responsive striped theadColor="purple" theadTextWhite data={KsbpM2} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะมนุษยศาสตร์และสังคมศาสตร์
        </Text>
        <MDBDataTableV5 responsive striped theadColor="orange" theadTextWhite data={KsbpM3} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะวิทยาการจัดการ
        </Text>
        <MDBDataTableV5 responsive striped theadColor="pink" theadTextWhite data={KsbpM4} />
      </Pane>
      <Text className="text-center mt-5" fontFamily="" fontSize={22} fontWeight={700}>
        อัตราค่าธรรมเนียมการศึกษา ระดับบัณฑิตศึกษา ปริญญาโท
      </Text>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะครุศาสตร์
        </Text>
        <MDBDataTableV5 responsive striped theadColor="light-blue" theadTextWhite data={BunditT2} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะวิทยาศาสตร์และเทคโนโลยี
        </Text>
        <MDBDataTableV5 responsive striped theadColor="yellow" data={BunditT1} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะวิทยาการจัดการ
        </Text>
        <MDBDataTableV5 responsive striped theadColor="pink" theadTextWhite data={BunditT4} />
      </Pane>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะมนุษยศาสตร์และสังคมศาสตร์
        </Text>
        <MDBDataTableV5 responsive striped theadColor="orange" theadTextWhite data={BunditT3} />
      </Pane>
      <Text className="text-center mt-5" fontFamily="" fontSize={22} fontWeight={700}>
        อัตราค่าธรรมเนียมการศึกษา ระดับบัณฑิตศึกษา ปริญญาเอก
      </Text>
      <Pane elevation={2} padding={15} borderRadius={8}>
        <Text fontFamily="" fontSize={20} fontWeight={700}>
          คณะครุศาสตร์
        </Text>
        <MDBDataTableV5 responsive striped theadColor="light-blue" theadTextWhite data={BunditD1} />
      </Pane>
    </Pane>
  );
}

export default Tuitionfees;
